import React from "react";
import "../all css/herohomesection.css";
const logo_self = require("../../assets/poster_1.png");
const video_hero_section2 = require("../../assets/A 20 second video of Lake Louise.mp4");
const video_hero_section = require("../../assets/DWEC Website homepage video 1920 X 1080.mp4");

function Herohomesection(props) {
  return (
    <section className="video_main_hero_container">
      <div className="hero_section_video_contianer">
        <video
          className="video_hero_section"
          loop
         // poster={logo_self}
          autoPlay
          muted
        >
          <source src={video_hero_section} type="video/mp4" />
        </video>
        <div className="cover_text_uppr_vdo">
          {/* <div className="cover_text_logo_container">
            <img
              src={logo_self}
              alt="dwec_logo"
              className="dwec_logo_cover_img"
            />
          </div> */}
          <p className="title_dwec_simple_text">
            Simplifying your journey to <br /> study abroad
          </p>
        </div>
      </div>
    </section>
  );
}

export default Herohomesection;
